module.exports = __webpack_public_path__ + "img/ring-shout.f82026ae.png";